export {default as quadtree} from "./quadtree.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/index.js
// module id = 111
// module chunks = 0